import { Q1 } from './Q1';
import { Q2 } from './Q2';
import { Q3 } from './Q3';
import { Q4 } from './Q4';
import { Q5 } from './Q5';
import { Q6 } from './Q6';
import { Q7 } from './Q7';
import { Q8 } from './Q8';
import { Q9 } from './Q9';
import { Q10 } from './Q10';
import { Q11 } from './Q11';
import { Q12 } from './Q12';
import { Q13 } from './Q13';
import { Q14 } from './Q14';
import { Q15 } from './Q15';
import { Q16 } from './Q16';
import { Q17 } from './Q17';
import { Q18 } from './Q18';
import { Q19 } from './Q19';
import { Q20 } from './Q20';
import { Q21 } from './Q21';
import { Q22 } from './Q22';
import { QuestionData } from '../types';

export const questions: QuestionData[] = [
  Q1,
  Q2,
  Q3,
  Q4,
  Q5,
  Q6,
  Q7,
  Q8,
  Q9,
  Q10,
  Q11,
  Q12,
  Q13,
  Q14,
  Q15,
  Q16,
  Q17,
  Q18,
  Q19,
  Q20,
  Q21,
  Q22,
];

export { Q1, Q2, Q3, Q4, Q5, Q6, Q7, Q8, Q9, Q10, Q11, Q12, Q13, Q14, Q15, Q16, Q17, Q18, Q19, Q20, Q21, Q22 }; 